var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.8.647a2.395 2.395 0 0 1 3.274 0l.798.746c.225.21.518.332.826.342l1.091.036a2.395 2.395 0 0 1 2.315 2.315l.036 1.092c.01.307.132.6.342.826l.747.797a2.395 2.395 0 0 1 0 3.273l-.747.798a1.27 1.27 0 0 0-.342.826l-.036 1.092a2.395 2.395 0 0 1-2.315 2.314l-1.091.036a1.27 1.27 0 0 0-.826.343l-.798.745a2.395 2.395 0 0 1-3.273 0l-.798-.746a1.27 1.27 0 0 0-.826-.342l-1.091-.036a2.395 2.395 0 0 1-2.315-2.315l-.036-1.091a1.27 1.27 0 0 0-.342-.826l-.747-.798a2.395 2.395 0 0 1 0-3.273l.747-.798a1.27 1.27 0 0 0 .342-.825l.036-1.092a2.395 2.395 0 0 1 2.315-2.314l1.092-.036a1.27 1.27 0 0 0 .826-.343zm5.142 5.925a.562.562 0 1 0-.821-.769L7.318 9.865 5.754 8.194a.563.563 0 0 0-.82.769l1.974 2.11a.56.56 0 0 0 .821 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckIcon;